<template>
    <div  class=" bg">
        <img :src="require(`@/static/image/index/warn.png`)" alt="" class="bg_img">
{{agentTitle}}
    </div>
</template>

<script>
import config from '@/config/config';
export default {
    name: '',
    components: {},
    data() {
        return {
         agentTitle:'',
        };
    },
    computed: {},
    watch: {},
    methods: {
           getConfig() {
            this.$api.index.getConfig().then(res => {
                if (res.code == 200) {
                    console.log(2444444)
                    this.agentTitle=res.data.agentTitle
                }
            })
        },
    },
    mounted() {
      this.getConfig()
    }
}
</script>
<style lang='scss' scoped>
.bg{
height: 50px;
background: #FFF5D1;
border-radius: 4px;
margin-top: 30px;
font-family: Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #845B00;
line-height: 50px;
display: flex;
align-items: center;
.bg_img{
    margin: 0 10px 0 25px;
    width: 18px;
    height: 18px;
}
}
</style>